import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api.js';

const URL = `${process.env.REACT_APP_API_URL}/api/fruttiDemo2`;

export const fetchFruits = createAsyncThunk(
  'fruits/fetchFruits',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(URL);
      return Array.isArray(res.data.frutti) ? res.data.frutti : [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error loading fruits');
    }
  }
);


export const addFruit = createAsyncThunk(
  'fruits/addFruit',
  async (fruit, { rejectWithValue }) => {
    try {
      const res = await api.post(URL, fruit);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error adding fruit');
    }
  }
);


export const editFruit = createAsyncThunk(
  'fruits/editFruit',
  async (fruit, { rejectWithValue }) => {
    try {
      const { id, nome, descrizione, categoria } = fruit;
      const res = await api.put(`${URL}/${id}`, { nome, descrizione, categoria });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error editing fruit');
    }
  }
);


export const deleteFruit = createAsyncThunk(
  'fruits/deleteFruit',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${URL}/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error deleting fruit');
    }
  }
);


const fruitsSlice = createSlice({
  name: 'fruits',
  initialState: {
    list: [],
    currentPage: 1,
    isLoading: false,
    error: null,
  },
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFruits.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFruits.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchFruits.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // add
      .addCase(addFruit.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(addFruit.rejected, (state, action) => {
        state.error = action.payload;
      })

      // edit
      .addCase(editFruit.fulfilled, (state, action) => {
        const index = state.list.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) state.list[index] = action.payload;
      })
      .addCase(editFruit.rejected, (state, action) => {
        state.error = action.payload;
      })

      // delete
      .addCase(deleteFruit.fulfilled, (state, action) => {
        state.list = state.list.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteFruit.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, clearError } = fruitsSlice.actions;
export default fruitsSlice.reducer;
